import ApiRequestManagerInstance from '../ApiRequestManager';
import EventUtils from '../../utils/events';
import FastEvent from '../../classes/fastEvent';
import { INextEpisodeRequest } from '../../types/interfaces/rail';

function nextEpisodeRequest(id: string): Promise<FastEvent | undefined> {
  const promise = new Promise<FastEvent | undefined>(async (resolve) => {
    try {
      const response: INextEpisodeRequest =
        (await ApiRequestManagerInstance.get({
          endpoint: {
            url: 'apiUrl',
            version: 'v1',
            section: 'apiseries',
            subsection: 'episodes',
            type: 'nextChapter',
            replacement: id,
          },
        })) as unknown as INextEpisodeRequest;

      const episode = EventUtils.createEvent(response.data) as FastEvent;
      resolve(episode);
    } catch (e) {
      console.error(e);
      resolve(undefined);
    }
  });

  return promise;
}

export default nextEpisodeRequest;
